import { AnswerInterface } from '../../domain/interface/answer_interface';
import { AnswerRepository } from '../../domain/repository/answer_repository';
import { AnswerApiService } from '../data_source/answer_api_service';

export class AnswerRepositoryImpl implements AnswerRepository {
  private readonly answerApiService: AnswerApiService;

  constructor() {
    this.answerApiService = new AnswerApiService();
  }

  async getUserAnswersByThemeId(themeId: string, type: 'start' | 'end'): Promise<AnswerInterface[]> {
    const response = await this.answerApiService.getUserAnswersByThemeId(
      themeId,
      type,
    );
    return response.data;
  }
}
